/** Admin-configured `end_date` on the client — not BE `event: null`. */
export function isPastEndDate(
	endDate: Date | null | undefined,
	nowMs: number = Date.now(),
): boolean {
	return (
		endDate instanceof Date &&
		Number.isFinite(endDate.getTime()) &&
		nowMs >= endDate.getTime()
	);
}
